<template>
    <v-container class="mb-5">
        <v-card v-if="form_data" class="pa-2">
            <v-card-text>
                <v-row no-gutters>
                    <v-col cols="12" style="height:500px">
                        <FileUploadArea :file-upload="fileUpload"
                                        :form_data="form_data"
                                        :upload-drop="upload_drop"
                                        :upload-change="upload_change"/>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import {$t} from "@/i18n";
import Vue from "vue";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import {computed, ref, watch} from "@vue/composition-api";
import {Router} from "@/composables/Router";
import AppModule from "../../../../store/modules/app";
import DetailViewHeader from "../../../../components/DetailViewHeader";
import FileUpload from "../../../../composables/FileUpload";
import ApiImport from "@/api/integration/import"
import FileUploadArea from "@/views/Import/Xlsx/FileUpload/FileUploadArea";

export default {
    name: "ImportWorkflow",
    components: {
        DetailViewHeader,
        FileUploadArea,
    },
    props: {
        relatedType: {
            // client_workflow
            // project_workflow
            type: String,
            required: true
        },
    },
    setup(props) {
        const appModule = AppModule();
        const router = Router();

        const loading = ref(false);
        const form_data = ref(null);
        const account_id = ref(router.currentRoute.params.account_id ? router.currentRoute.params.account_id : 0);

        const load_data = function () {
            form_data.value = {
                id: 0,
                account_id: account_id.value,
                related_type: props.relatedType,
                status: "new",
                files: [],
                file_type: null,
                files_error: null,
            };
        };
        const fileUpload = FileUpload(props.relatedType, form_data, form_data, false, null, null, false);

        const save_and_next = function () {
            router.push({name: "app_store", params: {accountId: account_id.value}});
        };

        const ensure_upload_session = async function () {
            try {
                if (form_data.value.id !== 0) {
                    // do nothing
                } else {
                    const resp = await ApiImport.saveImportSession(form_data.value)
                    Vue.sync_item_changes(form_data.value, resp, true);
                }
            } catch (e) {
                errorDialog.showError(e)
            }
        };

        const upload_drop = async function (e) {
            e.preventDefault();
            const files = [...e.dataTransfer.items].map(item => item.getAsFile());

            await ensure_upload_session()
            fileUpload.upload_drop({
                dataTransfer: {
                    files: files
                }
            })
        };
        const upload_change = async function (e) {
            await ensure_upload_session()
            fileUpload.upload_change(e);
        };

        const current_file_progress = computed(function () {
            if (appModule.current_upload_progress_total.value === 0) return 0;
            return (appModule.current_upload_progress_loaded.value * 100) / appModule.current_upload_progress_total.value;
        });

        const upload_progress = computed(function () {
            if (fileUpload.upload_state.total_files === 0) return 0;
            return (
                (fileUpload.upload_state.uploaded_files * 100) / fileUpload.upload_state.total_files +
                current_file_progress.value / fileUpload.upload_state.total_files
            );
        });

        load_data();

        watch(() => fileUpload.upload_state.uploaded_files, (val) => {
            if (val >= 1) {
                save_and_next()
            }
        })

        return {
            form_data,
            loading,
            save_and_next,
            fileUpload,
            upload_drop,
            upload_progress,
            upload_change,
            account_id,
        };
    }
};
</script>
